import React from 'react';
import OperatorForkliftActions from './OperatorForkliftActions';
import OperatorForkliftAvailability from './OperatorForkliftAvailability';
import { getForkliftMakeModel, getForkliftSerialNumber } from './operatorDashboardUtils';

export default function OperatorForkliftMobileCard({
  busy,
  forklift,
  onSafetyReport,
  onSelect,
  onStartChecklist,
  selected,
}) {
  return (
    <article
      className={`operator-forklift-card shared-selected-card${selected ? ' is-selected' : ''}`}
      onClick={() => onSelect(forklift.id)}
    >
      <div className="operator-forklift-card-header">
        <div>
          <div className="operator-forklift-card-eyebrow">Unit ID</div>
          <div className="operator-forklift-card-unit">{forklift.unitId || 'Unassigned'}</div>
        </div>
        <div className="operator-forklift-card-status">
          <OperatorForkliftAvailability forklift={forklift} compact />
        </div>
      </div>

      <dl className="operator-forklift-card-details">
        <div>
          <dt>Make / Model</dt>
          <dd>{getForkliftMakeModel(forklift)}</dd>
        </div>
        <div>
          <dt>Serial Number</dt>
          <dd>{getForkliftSerialNumber(forklift)}</dd>
        </div>
      </dl>

      <OperatorForkliftActions
        busy={busy}
        forklift={forklift}
        layout="mobile"
        onSafetyReport={onSafetyReport}
        onStartChecklist={onStartChecklist}
      />
    </article>
  );
}
